import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TimeTrackingData } from '../types';

type Props = {
  data: TimeTrackingData;
};

const TimeTrackingWidget: React.FC<React.PropsWithChildren<Props>> = ({
  data,
}) => {
  const { t } = useTranslation();
  const isActive = data.status === 'clocked_in';

  const STATUS_LABELS: Record<
    NonNullable<TimeTrackingData['status']>,
    string
  > = {
    clocked_in: t('aiChat.widgets.timeTracking.clockedIn'),
    clocked_out: t('aiChat.widgets.timeTracking.clockedOut'),
    paused: t('aiChat.widgets.timeTracking.paused'),
  };

  return (
    <div className="ai-chat-widget ai-chat-widget-time">
      {/* No status means the clock could not be read. Showing an empty pill —
          or worse, defaulting to "Clocked Out" — states something nothing
          checked (FLA-8234). */}
      {data.status && (
        <div className="ai-chat-widget-time-header">
          <span
            className={`ai-chat-widget-time-dot ${isActive ? 'active' : ''}`}
          />
          <span className="ai-chat-widget-time-status">
            {STATUS_LABELS[data.status]}
          </span>
          {isActive && data.elapsed && (
            <span className="ai-chat-widget-time-elapsed">{data.elapsed}</span>
          )}
        </div>
      )}
      <div className="ai-chat-widget-time-stats">
        <div className="ai-chat-widget-time-stat">
          <span className="ai-chat-widget-time-stat-value">
            {data.todayTarget}
          </span>
          <span className="ai-chat-widget-time-stat-label">
            {t('aiChat.widgets.timeTracking.todayTarget')}
          </span>
        </div>
        <div className="ai-chat-widget-time-stat">
          <span className="ai-chat-widget-time-stat-value">
            {data.weekTotal}
          </span>
          <span className="ai-chat-widget-time-stat-label">
            {t('aiChat.widgets.timeTracking.thisMonth')}
          </span>
        </div>
        <div className="ai-chat-widget-time-stat overtime">
          <span className="ai-chat-widget-time-stat-value">
            {data.overtime}
          </span>
          <span className="ai-chat-widget-time-stat-label">
            {t('aiChat.widgets.timeTracking.overtime')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TimeTrackingWidget;
